import { provideNzIcons } from 'ng-zorro-antd/icon';
import { IcIcons } from 'libs/core/src/lib/configs/icons';
import { AuthService } from 'libs/core/src/lib/services/auth.service';
import { IcHttpConfigInterceptor } from 'libs/core/src/lib/interceptors/ic-http-interceptor.interceptor';
import { provideDarkMode } from 'libs/core/src/lib/services/dark-mode.service';
import { providePortalName } from 'libs/core/src/lib/services/notice.service';
import { provideImpersonationMode } from 'libs/core/src/lib/services/impersonation.service';
import { provideImpersonationReadOnlyMode } from 'libs/core/src/lib/interceptors/impersonation-read-only.interceptor';
import { IcHttpCachingConfig } from 'libs/core/src/lib/configs/http-cache';
import { IProductsServiceToken } from 'libs/core/src/lib/services/products.service';
import { IUsersServiceInjectionToken } from 'libs/core/src/lib/services/users.service';
import { provideTenantTheme } from 'libs/core/src/lib/services/tenant-config.service';
import { RouteTitleStrategy } from 'libs/core/src/lib/route-title-stratagy';
import { en_US, NZ_I18N } from 'ng-zorro-antd/i18n';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzModalService } from 'ng-zorro-antd/modal';
import { provideRouter, Route, TitleStrategy } from '@angular/router';

import { InsurerProductsService } from './app/Services/insurer-products.service';
import { InsurerUsersService } from './app/Services/insurer-users.service';
import { InsurerAuthService } from './app/Services/insurer-auth-service';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { resolveRepresentative } from './app/insurer.resolver';
import { loginGuard } from './app/login.guard';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr
} from '@angular/common/http';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { NgHttpCachingModule } from 'ng-http-caching';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { AppComponent } from './app/app.component';
import { importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import {
  initializeSentry,
  provideSentryTracing,
} from '../../../libs/core/src/lib/sentry';
import { provideNzDateFnsAdapter } from 'ng-zorro-antd/core/time';
import { provideHighcharts } from 'highcharts-angular';


const routes: Route[] = [
  {
    path: '',
    loadChildren: () =>
      import('libs/shared-modules/src/lib/login/login.module').then((m) => m.LoginModule),
    title: 'Login',
    data: { portal: 'Insurer portal' },
  },
  {
    path: 'dashboard',
    resolve: { data: resolveRepresentative },
    canActivate: [loginGuard],
    loadChildren: () =>
      import('./app/dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
];

initializeSentry('Company Portal');
bootstrapApplication(AppComponent, {
  providers: [
    providePortalName('company-portal'),
    provideNzIcons(IcIcons),
    provideZoneChangeDetection(),
    provideHighcharts(),
    importProvidersFrom(
      BrowserModule,
      FormsModule,
      LoadingBarModule,
      LoadingBarHttpClientModule,
      NgHttpCachingModule.forRoot(IcHttpCachingConfig),
      LoadingBarRouterModule,
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: IcHttpConfigInterceptor,
      multi: true,
    },
    { provide: NZ_I18N, useValue: en_US },
    { provide: NzNotificationService },
    { provide: NzModalService },
    { provide: TitleStrategy, useClass: RouteTitleStrategy },
    {
      provide: IProductsServiceToken,
      useClass: InsurerProductsService,
    },
    {
      provide: IUsersServiceInjectionToken,
      useClass: InsurerUsersService,
    },
    {
      provide: AuthService,
      useClass: InsurerAuthService,
    },
    provideImpersonationMode(),
    provideImpersonationReadOnlyMode(),
    provideTenantTheme(),
    provideDarkMode(),
    provideRouter(routes),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
     provideSentryTracing(), provideNzDateFnsAdapter(),
  ],
}).catch((err) => console.error());
